import { defineAsyncComponent } from 'vue'
export default {
  default: defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/default.vue").then(m => m.default || m)),
  "high-end-jewelry": defineAsyncComponent(() => import("/opt/buildhome/repo/layouts/highEndJewelry.vue").then(m => m.default || m))
}